import React from 'react';

import { NavLink, useLocation } from 'react-router-dom';

import { AccountItem } from './AccountItem';

import { Nav } from '../../../../Shared/components-v2/nav/nav';
import { navItemStyles } from '../../../../Shared/components-v2/nav/nav-link-styles';
import { urlBuilder } from '../../../../Shared/urlBuilder';
import { useProcessNavTransition } from '../../../hooks/useProcessNavTransition';
import { EnvelopesQuery } from '../graphql/query.envelopes.generated';

type Envelope = EnvelopesQuery['envelopes'][number];
type Props = { envelope: Envelope };

export const EnvelopeItem: React.FC<Props> = ({ envelope }) => {
  const onClick = useProcessNavTransition();
  const location = useLocation();

  const { purpose } = envelope;

  if (!purpose) {
    return (
      <>
        {envelope.accounts.map(account => (
          <AccountItem key={account.id} account={account} />
        ))}
      </>
    );
  }

  const accountUrls = envelope.accounts.map(account => {
    return account.__typename === 'CheckingAccount'
      ? account.remote && urlBuilder.getAppCheckingSummary({ accountId: account.remote.checkingAccountId })
      : urlBuilder.appAccount({ accountId: account.id });
  });

  const isAccountActive = accountUrls.includes(location.pathname);

  return (
    <NavLink
      key={envelope.id}
      className={navItemStyles({ spacing: 'expanded' })}
      to={urlBuilder.appPurpose({ purposeId: purpose.id })}
      onClick={onClick}
      data-active={isAccountActive}
    >
      <Nav.Icon asChild={true}>
        <img src={purpose.image.dark} alt="" />
      </Nav.Icon>
      <Nav.Text>{purpose.name}</Nav.Text>
    </NavLink>
  );
};
